/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod';

export const referralsGetResponseSchema = z.object({
  data: z.object({
    company: z
      .object({
        pending_referrals: z.number().int(),
        total_referral_credit: z.string(),
        total_referrals: z.number().int(),
      })
      .optional(),
    referral_link: z.string().optional(),
    show_referrals: z.boolean().optional(),
  }),
  response: z.object({
    date: z.string(),
    messages: z.array(z.string()),
    status: z.number().int(),
    type: z.string(),
  }),
});
